<template>
  <div class="loadingModal" v-if="progressLoading">
    <el-progress
      :style="{width:'20%',}"
      :width="70"
      :text-inside="true"
      type="line"
      :stroke-width="strokeWidth"
      :percentage="percentage"
      :color="colors"
      :show-text="showText"
      :status="percentage === 100 ? undefined : 'success'"
    ></el-progress>

    <div class="tipText">{{tipText}}</div>
  </div>
</template>

<script>
export default {
  name: 'index',
  props: {
    strokeWidth: {
      type: Number,
      default: () => {
        return 16
      }
    },
    showText: {
      type: Boolean,
      default: true
    },
    // 显示状态
    loading: {
      type: Boolean,
      default: false
    },
    percentage: {
      type: Number,
      default: 0
    },
    tipText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {

      timeStart: 0,
      colors: [
        { color: '#1989fa', percentage: 99 },
        { color: '#2BD176', percentage: 100 }
      ],
      progressLoading: false
    }
  }
}
</script>

<style scoped lang="scss">
.loadingModal {
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 2000;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .tipText {
    color: #fff;
    margin-top: 20px;
    font-size: 18px;
  }
}
</style>
